import { z } from 'zod';

/**
 * Core session schemas that are shared across multiple files.
 * This file helps avoid circular dependencies by providing a central location
 * for core session-related schemas that are used by both session.ts and other files.
 */

// SessionStatus schema - core enum for session states
export const sessionStatusSchema = z.enum(['scheduled', 'completed', 'in_progress', 'cancelled', 'archived']);
export type SessionStatus = z.infer<typeof sessionStatusSchema>;
export const SessionStatus = sessionStatusSchema.enum;

export const coachSessionRemarkSchema = z.enum([
  'subClass',
  'subClassWithin12Hours',
  'canceled',
  'canceledWithin12Hours',
  'teacherNoShow',
  'teacherItIssue',
]);
export type CoachSessionRemark = z.infer<typeof coachSessionRemarkSchema>;
export const CoachSessionRemark = coachSessionRemarkSchema.enum;

export const coachSessionRemarkV2Schema = z.enum([
  'canceled',
  'canceledWithin12Hours',
  'subClass',
  'subClassWithin12Hours',
  'lateStart',
  'endEarly',
  'tns',
]);
export type CoachSessionRemarkV2 = z.infer<typeof coachSessionRemarkV2Schema>;
export const CoachSessionRemarkV2 = coachSessionRemarkV2Schema.enum;
